module.exports = __webpack_public_path__ + "static/media/featured-stone-active.2fd865c2.svg";